module.exports = __webpack_public_path__ + "resources/img/sp_member.2ace6c21ca37a428d6af054c74898477.png";